import { render, staticRenderFns } from "./ShipmentStatusReport.vue?vue&type=template&id=28f08b68"
import script from "./ShipmentStatusReport.vue?vue&type=script&lang=js"
export * from "./ShipmentStatusReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports